import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { cuentaEntity, detalleCuentaEntity, detalleIndicadorEntity, evaluacionesAllEntity, evaluacionesEntity, gruposIndEntity, indicadorEntity, modIndEntity, sucursalesEntity, varTipoEntity } from './entities';

@Injectable({
  providedIn: 'root'
})
export class PresupuestoManualService {
  private readonly apiURL = environment.api_formulador;
  private readonly sufijos = 'api-fe';
  private readonly sufijoAll = 'api';
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token')); 
  constructor(
    private http: HttpClient,
  ) { }

  //TODO metodos provisinales por temas de evitar errores se debn sustituir por los servicios del backend manual
  public getSucursales(params: sucursalesEntity): Observable<any> {
    const apiURL = `${this.apiURL}${this.sufijoAll}/institucion/get-all`;
    
    let httpParams = this.getParams(params);

    return this.http.get(apiURL, {
      headers: this.headers,
      params: httpParams
    });
  }

  public getCuentasDescripcion(params: cuentaEntity): Observable <any>{
    const apiURL = `${this.apiURL}${this.sufijoAll}/cuenta/get-all`;
    
    let httpParams = this.getParams(params);

    return this.http.get(apiURL, {
      headers: this.headers,
      params: httpParams
    });
  }
  public getCuentasValor(params: detalleCuentaEntity): Observable <any>{
    const apiURL = `${this.apiURL}${this.sufijos}/detalle-cuenta`;
    
    let httpParams = this.getParams(params);

    return this.http.get(apiURL, {
      headers: this.headers,
      params: httpParams
    });
  }

  public getPeriodos(params: evaluacionesEntity): Observable<any>{
    const apiURL = `${this.apiURL}${this.sufijos}/evaluacion`;
    
    let httpParams = this.getParams(params);

    return this.http.get(apiURL, {
      headers: this.headers,
      params: httpParams
    });
  }
  public getPeriodosAll(params: evaluacionesAllEntity): Observable<any>{
    const apiURL = `${this.apiURL}${this.sufijoAll}/evaluacion/get-all`;
    
    let httpParams = this.getParams(params);

    return this.http.get(apiURL, {
      headers: this.headers,
      params: httpParams
    });
  }
  public getModuloIndicador(params: modIndEntity): Observable<any>{
    const apiURL = `${this.apiURL}${this.sufijoAll}/modulo/get-all`;
    
    let httpParams = this.getParams(params);

    return this.http.get(apiURL, {
      headers: this.headers,
      params: httpParams
    });
  }
  public getgrupoInd(params: gruposIndEntity): Observable<any>{
    const apiURL = `${this.apiURL}${this.sufijoAll}/grupo-indicador/get-all`;
    
    let httpParams = this.getParams(params);

    return this.http.get(apiURL, {
      headers: this.headers,
      params: httpParams
    });
  }
  public getIndicadoresPropiedades(params: indicadorEntity): Observable<any>{
    const apiURL = `${this.apiURL}${this.sufijoAll}/indicador/get-all`;
    
    let httpParams = this.getParams(params);

    return this.http.get(apiURL, {
      headers: this.headers,
      params: httpParams
    });
  }
  public getIndicadoresDescripcion(params: indicadorEntity): Observable<any>{
    const apiURL = `${this.apiURL}${this.sufijos}/indicador`;
    
    let httpParams = this.getParams(params);

    return this.http.get(apiURL, {
      headers: this.headers,
      params: httpParams
    });
  }
  public getIndicadoresValor(params: detalleIndicadorEntity): Observable<any>{
    const apiURL = `${this.apiURL}${this.sufijos}/detalle-indicador`;
    
    let httpParams = this.getParams(params);

    return this.http.get(apiURL, {
      headers: this.headers,
      params: httpParams
    });
  }
  public getindicadorGrupo(grupoIndicador: number): Observable<any>{
    const apiURL = `${this.apiURL}${this.sufijoAll}/grupo-indicador/${grupoIndicador}/indicadores`;
    
    return this.http.get(apiURL, {
      headers: this.headers
    });
  }
  public getVariableTipoDescripcion(params: varTipoEntity): Observable<any>{
    const apiURL = `${this.apiURL}${this.sufijoAll}/variable/get-all`;
    let httpParams = this.getParams(params);
    
    return this.http.get(apiURL, {
      headers: this.headers,
      params: httpParams
    });
  }
  public getVariableTipoValor(params: varTipoEntity): Observable<any>{
    const apiURL = `${this.apiURL}${this.sufijoAll}/detalle-variable/get-all`;
    let httpParams = this.getParams(params);
    
    return this.http.get(apiURL, {
      headers: this.headers,
      params: httpParams
    });
  }

  private getParams(params): HttpParams{
    let httpParams = new HttpParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        httpParams = httpParams.set(key, value.toString());
      }
    });
    httpParams = httpParams.set('active', 'true');
    return httpParams;
  }
}
